import AboutUs3Container from "../../../components/pages/other/AboutUs3";

const AboutUs3 = () => {
  return <AboutUs3Container />;
};

export default AboutUs3;
